module.exports = __webpack_public_path__ + "img/bmw.0f1a01eb.png";